import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
  color?: 'primary' | 'gray'
}

const ActivitiesModuleBrand: FC<Props> = ({ color = 'primary', size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    `${color}.200`,
    `${color}.300`,
    `${color}.400`,
    `${color}.500`,
    `${color}.600`,
    `${color}.700`,
    `${color}.900`,
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Atividades">
          <g id="background">
            <g id="group200">
              <path
                fill={fillColor200}
                opacity="0.25"
                d="M564.27,669.92C644.76,579.2,759.21,260.79,677.32,161.8c-107.21-129.59-271.13-1.69-394.8,35.56C-242.55,355.52,260.17,1012.68,564.27,669.92Z"
              />
            </g>
            <g id="group400">
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M552.61,665C579,692.19,619.06,704.42,658,692.85c52.08-15.46,84-69.3,72.86-123.1-.07-.36-.15-.72-.22-1.08a102.79,102.79,0,0,1,.66-45.24,64.17,64.17,0,0,0-1-32.94c-9.77-32.91-44.16-52.35-76.94-43.58-12.7,3.4-37.16,20.93-55.66,34.71-12.47,9.3-24.26,13.3-39,8.11-16.71-5.91-47.76,1.59-60.85,20.27-24.56,35-21.62,46.85-13.5,89.36,3.64,19.07.54,43.9,38.25,44.8C532.89,644.41,545.44,657.57,552.61,665Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M247.43,175.68C215.2,159,174,160.18,140.09,182.6c-45.31,30-61.35,88.56-36.65,134l.5.91a92.62,92.62,0,0,1,11.3,41.26,57.46,57.46,0,0,0,9.65,29.59c17.93,26.88,55.68,34,84.45,16,11.16-7,29.73-30.35,43.64-48.52,9.38-12.25,19.5-19.49,34.81-19.27,17.4.25,44.87-16.05,52.37-37,14-39.31,8.15-49.13-10.75-85.23-8.48-16.2-12.09-39.69-48.09-29C271.56,188.3,256.19,180.2,247.43,175.68Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M733.88,384.7c26.83-26.81,38.46-67,26.31-105.83C744,227,689.65,196,636,207.85l-1.07.25a102.93,102.93,0,0,1-45.24,0,64.09,64.09,0,0,0-32.93,1.51c-32.76,10.26-51.69,44.93-42.43,77.58,3.59,12.65,21.48,36.85,35.54,55.13,9.48,12.34,13.66,24.07,8.68,38.84-5.65,16.79,2.31,47.73,21.18,60.54,35.4,24,47.17,20.92,89.55,12.17,19-3.92,43.89-1.2,44.23-38.92C713.62,404.73,726.59,392,733.88,384.7Z"
              />
            </g>
            <g id="group600">
              <path
                fill={fillColor600}
                d="M29.05,628.57a31.68,31.68,0,0,0,14.89,35.06c12.58,7.34,28.43,16.7,32.3,16,18-3-10.3-73.95-20.48-81.3C44.18,590,33.83,609.76,29.05,628.57Z"
              />
              <path
                fill={fillColor600}
                d="M751.14,159.12c-1.61-16.53-27.59-24.71-38.45-16.83-13.13,9.55,12.74,42.74,26.06,53C746.22,196.61,752,171,751.14,159.12Z"
              />
              <path
                fill={fillColor600}
                d="M466.52,204.8c-113.38-43-384.86,22.29-409.93,148.29-32.81,165,150.67,235.5,262.7,299.77C714.39,879.54,871.15,358.39,466.52,204.8Z"
              />
              <path
                fill={fillColor600}
                d="M283.62,70.09c61.52-93.07,38.92,1.39,48.57,16s1,27.35-13.64,37-47.72,14.41-57.36-.23S269.5,91.46,283.62,70.09Z"
              />
            </g>
          </g>
          <g id="icon">
            <path
              fill={fillBG}
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M497.32,227.37H540.6c23.92-.26,43.5,23.45,43.5,52.43V595.93h0c0,29-19.58,52.69-43.5,52.69h-261l-.22,0c-24.14-.27-43.5-23.71-43.5-53h0V279.51h0c-.22-29.24,19.36-52.95,43.28-52.95h43.5"
            />
            <path
              fill={'none'}
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M481.71,384.3l-86.86,86.86-52.31-52.3"
            />
            <rect
              fill={fillBG}
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              x="323.32"
              y="183.73"
              width="174"
              height="87"
              rx="21.75"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(ActivitiesModuleBrand)
